import { Kevel } from './kevel.js?v=2.3';

const fdKevel = new Kevel();
fdKevel
  .setDivName('sponsored-brand')
  .load(
    [
      {
        divName: 'sponsored-brand',
        networkId: 11757,
        siteId: 1303014,
        zoneIds: [329946],
        adTypes: [11424],
        eventIds: [40],
      },
    ],
    [`page=${window.location.pathname}`]
  )
  .onSuccess((ev) => {
    const data = ev.detail;
    if (data.decisions['sponsored-brand'] != null) {
      fetch(data.decisions['sponsored-brand'].impressionUrl);
      const campaignContent = data.decisions['sponsored-brand'].contents[0];
      const collectionHeader = document.getElementById('sponsored-brand');
      collectionHeader.classList.add('page-width');
      collectionHeader.style.height = 'auto';
      const collectionHeaderPaddingTop = collectionHeader.dataset.paddingTop;
      const collectionHeaderPaddingBottom = collectionHeader.dataset.paddingBottom;

      if (campaignContent.data.ctrawClick === 'null') {
        collectionHeader.removeAttribute('href');
        collectionHeader.style.pointerEvents = 'none';
        collectionHeader.style.touchAction = 'none';
      } else {
        collectionHeader.href = data.decisions['sponsored-brand'].clickUrl;
      }

      const collectionHeaderContent = document.getElementById('sponsored-brand-content');
      collectionHeaderContent.classList.add('sponsored-brand-content');
      collectionHeaderContent.style.backgroundColor = campaignContent.data.ctBackgroundColor;

      const collectionHeaderMedia = document.createElement('div');
      collectionHeaderMedia.classList.add('sponsored-brand-media');

      const collectionHeaderMediaPicture = document.createElement('picture');
      collectionHeaderMediaPicture.classList.add('picture');

      if (campaignContent.data.ctMobileImage != null) {
        const collectionHeaderMediaPictureSource = document.createElement('source');
        collectionHeaderMediaPictureSource.media = '(max-width: 749px)';
        collectionHeaderMediaPictureSource.srcset = `https://s.zkcdn.net/Advertisers/${campaignContent.data.ctMobileImage}`;
        collectionHeaderMediaPictureSource.dataset.bannerPromo = 'slide';
        collectionHeaderMediaPicture.appendChild(collectionHeaderMediaPictureSource);
      }

      collectionHeaderContent.textContent = '';
      const collectionHeaderMediaPictureImage = document.createElement('img');
      collectionHeaderMediaPictureImage.src = `https://s.zkcdn.net/Advertisers/${campaignContent.data.ctDesktopImage}`;
      collectionHeaderMediaPictureImage.loading = 'lazy';
      collectionHeaderMediaPictureImage.classList.add('image');
      collectionHeaderMediaPictureImage.sizes = '100vw';
      collectionHeaderMediaPictureImage.fetchPriority = 'auto';
      collectionHeaderMediaPicture.appendChild(collectionHeaderMediaPictureImage);
      collectionHeaderMedia.appendChild(collectionHeaderMediaPicture);
      collectionHeaderContent.appendChild(collectionHeaderMedia);
      collectionHeader.appendChild(collectionHeaderContent);
      collectionHeader.style.paddingTop = collectionHeaderPaddingTop;
      collectionHeader.style.paddingBottom = collectionHeaderPaddingBottom;

      collectionHeaderContent.dataset.bannerPromo = 'banner';
      collectionHeaderContent.dataset.bannerId = data.decisions['sponsored-brand'].flightId || null;
      collectionHeaderContent.dataset.bannerName = campaignContent.data.ctcampaignName || 'none';
      collectionHeaderContent.dataset.creativeSlot = campaignContent.data.ctcreativeSlot || 'none';
      collectionHeaderContent.dataset.itemId = campaignContent.data.ctid || 'none';
      collectionHeaderContent.dataset.bannerIndex = 1;
      collectionHeaderContent.dataset.bannerImg =
        `https://s.zkcdn.net/Advertisers/${campaignContent.data.ctDesktopImage}` ||
        `https://s.zkcdn.net/Advertisers/${campaignContent.data.ctMobileImage}`;
      collectionHeaderContent.classList.remove('animated');

      fdKevel.sendViewableImpression(collectionHeader, data.decisions['sponsored-brand']);
    } else {
      const collectionHeader = document.getElementById('sponsored-brand');
      collectionHeader.style.display = 'none';
    }
  });
